import LeaderboardDaysCard from "./LeaderboardDaysCard";
import Spinner from "../spinner/Spinner";
import LeaderBoardStyles from "./LeaderBoardStyles.module.css";
import {LeaderBoardDaysProps} from "../../types/ComponentProps";

const LeaderboardDaysList = ({
  leaderboardData,
  loadingLeaderboard,
}: LeaderBoardDaysProps) => {
  const leaderboard = leaderboardData?.showSevenDaysLeaderboard ?? [];

  return (
    <div className={LeaderBoardStyles?.leaderboardListContainer}>
      {loadingLeaderboard ? (
        <Spinner alignSpin="center-spinner" variant="small-spinner" />
      ) : (
        leaderboard
          .slice(0, 5)
          .map((data) => {
            console.log("Rendering card for user ID:", data.user.id);
          return <LeaderboardDaysCard key={data.user.id} data={data} />})
      )}
    </div>
  );
};

export default LeaderboardDaysList;
